import { render, staticRenderFns } from "./AssetsBlack.vue?vue&type=template&id=b12bccde&scoped=true"
import script from "./AssetsBlack.vue?vue&type=script&lang=js"
export * from "./AssetsBlack.vue?vue&type=script&lang=js"
import style0 from "./AssetsBlack.vue?vue&type=style&index=0&id=b12bccde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12bccde",
  null
  
)

export default component.exports